module.exports = __webpack_public_path__ + "static/media/mp.fec806e5.svg";